import { graphql } from '@data-access/graphql'
import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core'

export const PartnerProfileDocument = graphql(`
  query partnerProfile($publicId: Int!, $previewToken: String) {
    partnerProfile(publicId: $publicId, previewToken: $previewToken) {
      publicId
      slug
      name
      city
      tagline
      memberSince
      aboutText
      experienceCount
      profileImage {
        url
        alt
      }
      galleryImages {
        url
        alt
      }
      categories {
        key
        label
      }
      upcomingDates {
        publicId
        slug
        title
        startsAt
        durationMinutes
        priceFrom
      }
    }
  }
`)

// Narrower than the full profile query on purpose. `upcomingDates` is an
// uncached field resolver that calls the experience service on every read, and
// the modal shows neither it nor galleryImages/categories.
export const PartnerProfileModalDocument = graphql(`
  query partnerProfileModal($publicId: Int!, $previewToken: String) {
    partnerProfile(publicId: $publicId, previewToken: $previewToken) {
      publicId
      slug
      name
      city
      tagline
      memberSince
      aboutText
      experienceCount
      profileImage {
        url
        alt
      }
    }
  }
`)

export type PartnerProfileQuery = ResultOf<typeof PartnerProfileDocument>
export type PartnerProfileQueryVariables = VariablesOf<typeof PartnerProfileDocument>
export type PartnerProfileModalQuery = ResultOf<typeof PartnerProfileModalDocument>
export type PartnerProfileModalQueryVariables = VariablesOf<typeof PartnerProfileModalDocument>
